import type { ReactNode } from 'react';
import React from 'react';
import * as Sentry from '@sentry/react';

import { useOrganizationWeekPlanner } from 'state/context/organization/OrganizationWeekPlanner';

import { useOrganisationJobDetail } from 'state/context/organization/OrganisationJobDetail';

const FallbackWrapper: React.FC<{ children: ReactNode }> = ({ children }) => {
  const organizationWeekPlanner = useOrganizationWeekPlanner();
  const organizationJobDetails = useOrganisationJobDetail();

  Sentry.configureScope((scope) => {
    scope
      .setLevel('error')
      .setExtra('Organization Job Detail Context', organizationJobDetails)
      .setExtra('Organization Week Planner Context', organizationWeekPlanner);
  });
  return <>{children}</>;
};

export default FallbackWrapper;
